import type { IApplication } from "models/Workspace.model";

export const userCanAccessApplicationPolicy = (
  application: Pick<IApplication, "policy">,
  userIdentities: readonly string[],
) =>
  (application.policy?.allowEveryone ?? false) ||
  (application.policy?.allowedUserAuthIDs ?? []).some((identity) =>
    userIdentities.includes(identity),
  );
